import { IRootState } from '../../../store'
import { IInitiateIvOptionsState } from '../store/options.types'

export const getInitiateIvOptionsSelector = (state: IRootState): IInitiateIvOptionsState =>
  state.options.initiateIvOptions
